import React from 'react'
import clsx from 'clsx'
import ShowMoreText from 'react-show-more-text'

import Tooltip from '@SonarCX/components/atoms/Tooltip'
import FavoriteButton from '@SonarCX/components/atoms/FavoriteButton'

import useStyles from './styles'

type TitleProps = {
  task: LocalTask
  isFavorite: boolean
  parentIcon?: React.ReactNode
}

const Title: React.FC<TitleProps> = ({
  task,
  isFavorite,
  parentIcon = null
}) => {
  const [expanded, setExpanded] = React.useState(false)

  const classes = useStyles()

  return (
    <div onClick={e => e.stopPropagation()} className={classes.root}>
      <Tooltip
        title={expanded || task.title.length <= 30 ? null : task.title}
        arrow
        placement='top'
      >
        <div
          className={clsx(
            classes.title,
            Boolean(task.closed_at) && classes.closed
          )}
        >
          <ShowMoreText
            lines={2}
            more='Show more'
            less='Show less'
            className={classes.content}
            anchorClass={classes.expand}
            onClick={setExpanded}
            expanded={expanded}
            keepNewLines
          >
            {task.title}
          </ShowMoreText>
        </div>
      </Tooltip>

      {parentIcon}

      <FavoriteButton isFavorite={isFavorite} type='task' itemId={task.id} />
    </div>
  )
}

export default Title
